import { createAction } from 'redux-actions';

const PREFIX = 'GET_BALANCE_WITH_DELAY';

export const getBalanceWithDelay = createAction(`${PREFIX}/getBalanceWithDelay`);
